import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeywordAutocompleteComponent } from '@apply4u/shared/components/keyword-autocomplete/keyword-autocomplete.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    KeywordAutocompleteComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports : [
    KeywordAutocompleteComponent
  ]
})

export class KeywordAutocompleteModule { }
